const benefitsSlider = $('#benefitsSlider');

if (benefitsSlider.length) {
    benefitsSlider.slick({
        dots: false,
        arrows: true,
        prevArrow: '<i class="fa benefits__arrows benefits__arrowLeft fa-chevron-left"></i>',
        nextArrow: '<i class="fa benefits__arrows benefits__arrowRight fa-chevron-right"></i>',
        adaptiveHeight: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000
    });
}